export const TBL = {
  loads: 'tbl:loads:v1',
  loadsInbox: 'tbl:loads:inbox:v1',
  importPreview: 'tbl:loads:import-preview:v1',
  pnl: 'tbl:reports:pnl:v1',
  audit: 'tbl:audit-log:v1',
  rateHistory: 'tbl:jobs:rate-history:v1',
  sites: 'tbl:sites:v1',
  products: 'tbl:products:v1',
  mills: 'tbl:mills:v1',
  vendors: 'tbl:vendors:v1',
  customers: 'tbl:customers:v1',
  manifests: 'tbl:loads:manifests:v1',
} as const
